import React from "react";
import ReactDOM from 'react-dom/client';
import { useNavigate, Navigate } from 'react-router-dom';
import { useEffect, useState, useRef, useMemo } from 'react'
import * as Auth from 'aws-amplify/auth';
import { get } from '@aws-amplify/api';
import { AgGridReact } from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { printConsole } from './utility'; 
import axios from 'axios';

export async function sepElements(list){

  const myAPI="mktappapi";
  let path = '/strategy';

  let recLst=[];
  let indRecLst=0;

  let maxChg="";
  let avgChg="";
  let wAvgChg="";
  let profitResponse="";
  let maxChgArrStr=[];
  let maxChgArrNum=[];
  let chgPercentCnt=0;
  let sumChgPercent=0;
  let wSumChgPercent=0;
  let wSum=0;
  let cnt33=0;
  let cnt66=0;
  let cnt100=0;
  
  await console.log("Executing sepElements");
  await console.log("sepElements : list = "+JSON.stringify(list));
  path = '/maxhistoricchg';
  maxChg="";
  avgChg="";
  wAvgChg="";
  //daysNowToExp=list[0]["daysNowToExp"];
  var passApistr=path + "/" + list[0].stock.toString() + "/" + list[0]["twoYearsAgo"] + "/" + list[0]["today"] + "/" + list[0]["daysNowToExp"];
  console.log("sepElement : passApistr = " +passApistr);
  const response = await get({
    apiName: myAPI,
    path: passApistr,
  }).response;
  let resp = await response.body.json();
  await Promise.resolve(resp)
    .then(resp =>{
      maxChg=resp;
      console.log("sepElement : initial maxChg = "+maxChg);
      // /maxhistoricchg returns a JSON array, so response.body.json() hands back
      // an array — not the comma-separated string this code used to assume.
      // Calling .split() on it threw a TypeError and left the weighted average
      // unset ("Invalid Number"). Accept either shape, and drop entries that are
      // not real numbers so an empty/error response yields 0 rather than NaN.
      maxChgArrStr = Array.isArray(maxChg)
        ? maxChg
        : String(maxChg ?? "").split(",");
      maxChgArrNum=[];
      for (var i=0; i<maxChgArrStr.length; i++) {
        var chgVal = parseInt(maxChgArrStr[i], 10);
        if (!Number.isFinite(chgVal)) {
          continue;
        }
        maxChgArrNum.push(chgVal);
        sumChgPercent=sumChgPercent+chgVal;
        if (chgVal>=0 && chgVal<=33) {
          cnt33++;
        } else if (chgVal>=34 && chgVal<=66) {
          cnt66++;
        } else {
          cnt100++;
        }
        chgPercentCnt++;
      }
      maxChg = maxChgArrNum.length > 0 ? Math.max(...maxChgArrNum).toString() : "0";
      avgChg = chgPercentCnt > 0 ? Math.round((sumChgPercent / chgPercentCnt)).toString() : "0";
      var num;
      for (i=0; i<maxChgArrNum.length; i++){
        if (maxChgArrNum[i]>=0 && maxChgArrNum[i]<=33) {
          wSumChgPercent=wSumChgPercent+maxChgArrNum[i]*cnt33;
          wSum=wSum+cnt33;
        } else if (maxChgArrNum[i]>=34 && maxChgArrNum[i]<=66) {
          wSumChgPercent=wSumChgPercent+maxChgArrNum[i]*cnt66;
          wSum=wSum+cnt66;
        } else {
          wSumChgPercent=wSumChgPercent+maxChgArrNum[i]*cnt100;
          wSum=wSum+cnt100;
        }
      }
      wAvgChg = wSum > 0 ? Math.round(wSumChgPercent / wSum) : (chgPercentCnt > 0 ? parseInt(avgChg) : 0);
      console.log("sepElement : maxChg = " + maxChg);
      console.log("sepElement : avgChg = " + avgChg);
      console.log("sepElement : wAvgChg = " + wAvgChg);

      var count = Object.keys(list).length;
      var i;
      var tmpLst={};
      for (i=0; i<count;i++) {
        list[i]["maxChangePercent"]=maxChg;
        list[i]["weightedAvgChgPercent"]=wAvgChg.toString();
        list[i]["avgChgPercent"]=avgChg.toString();
        tmpLst=list[i];
        
        console.log("sepElement : tmpLst = "+JSON.stringify(tmpLst));
        recLst[indRecLst]=tmpLst;
        indRecLst++;
        console.log("i = "+i+"\tcount = "+count+"\tindRecLst = "+indRecLst);
        //setAnalysis(oldArray => [...oldArray, tmpLst]);
      }
      /*for (i=0; i<recLst.length; i++){
        await console.log ("sepElement : recLst[" + i + "] = " + JSON.stringify(recLst[i]));
        await setAnalysis(oldArray => [...oldArray, recLst[i]]);
      }
      await setAnalysis(recLst);*/
      //Promise.resolve(recLst)
      console.log("printing recLst from sepElements function");
      console.log(recLst);
      console.log("finished printing recLst from sepElements");

      console.log("sepElements : recLst length = "+recLst.length);
      

  })
  return await recLst;
  /*console.log("sepElement : calculated : maxChg = " + maxChg);
  console.log("sepElement : calculated : avgChg = " + avgChg);
  console.log("sepElement : calculated : wAvgChg = " +wAvgChg);*/
    
}

export function loadRowData(strategyAnalysis, daysNowToExp, activeButton) {
  console.log("Executing loadRowData");
  console.log("loadRowData : activeButton = " + activeButton);
  let analysis = [];
  let rowdata = [];
  analysis = strategyAnalysis;
  let profit, adjProfit, depth, wAvgChange, minDepth;

  if (typeof(analysis)!='undefined') {
    console.log ("loadRowData : analysis = "+ JSON.stringify(analysis));
    var key=0;
    var count = Object.keys(analysis).length;
    console.log ("loadRowData : analysis length= "+count);
    var rank=0;
    for (key=0; key<count; key++) {
      try {
        profit=parseFloat(analysis[key]["profit"]);
        daysNowToExp=parseFloat(analysis[key]["daysNowToExp"]);
        adjProfit=profit*30/daysNowToExp;
        depth=parseFloat(analysis[key]["depth"]);
        wAvgChange=parseFloat(analysis[key]["weightedAvgChgPercent"]);
        minDepth=wAvgChange*0.75;
        if (adjProfit >= 0.9 && depth >= minDepth && depth < wAvgChange) {
          rank=2;
        } else if (adjProfit >= 0.6 && adjProfit <0.9 && depth >= minDepth) {
          rank=1;
        } else if (adjProfit >= 0.9 && depth >= wAvgChange){
          rank=3;
        } else {
          rank = 0;
        }
        if (analysis[key]["averageAnalystRating"].toString() === "null") {
          analysis[key]["averageAnalystRating"] = "";
        }
        if (analysis[key]["earningsTimestampStart"].toString() === "null") {
          analysis[key]["earningsTimestampStart"] = "";
        }
      } catch(err) { };
      if (activeButton.toString().toLowerCase() === "inthemoney") {
        rowdata[key]={
          id: key,
          expanded: false,
          security: analysis[key]["stock"],
          name: analysis[key]["name"],
          ranking: rank,
          analystRating: analysis[key]["averageAnalystRating"],
          details: "> ",
          stockOffer: parseFloat(analysis[key]["stockOffer"]),
          dbTimestamp: analysis[key]["dbTimestamp"],
          expiration: analysis[key]["expire"],
          lastSale: parseFloat(analysis[key]["lastSale"]),
          strike: parseFloat(analysis[key]["strike"]),
          earningsDate: analysis[key]["earningsTimestampStart"],
          maxChange: parseFloat(analysis[key]["maxChangePercent"]),
          bid: parseFloat(analysis[key]["bid"]),
          offer: parseFloat(analysis[key]["ask"]),
          openInterest: parseInt(analysis[key]["openInterest"]),
          volume: parseInt(analysis[key]["volume"]),
          profit: parseFloat(analysis[key]["profit"]),
          annualProfit: parseFloat(analysis[key]["annualProfit"]),
          depth: parseFloat(analysis[key]["depth"]),
          wAvgChange: parseFloat(analysis[key]["weightedAvgChgPercent"]),
          impliedVol: parseFloat(analysis[key]["impliedVol"]),
          impliedPeriod: parseFloat(analysis[key]["impliedPeriod"]),
          minPrice: parseFloat(analysis[key]["minPrice"]),
          maxPrice: parseFloat(analysis[key]["maxPrice"])
          
        }
      }
      if (activeButton.toString().toLowerCase() === "outofthemoney") {
        rowdata[key]={
          id: key,
          expanded: false,
          security: analysis[key]["stock"],
          name: analysis[key]["name"],
          ranking: 0,
          analystRating: analysis[key]["averageAnalystRating"],
          details: "> ",
          stockOffer: parseFloat(analysis[key]["stockOffer"]),
          dbTimestamp: analysis[key]["dbTimestamp"],
          expiration: analysis[key]["expire"],
          lastSale: parseFloat(analysis[key]["lastSale"]),
          strike: parseFloat(analysis[key]["strike"]),
          earningsDate: analysis[key]["earningsTimestampStart"],
          maxChange: parseFloat(analysis[key]["maxChangePercent"]),
          bid: parseFloat(analysis[key]["bid"]),
          offer: parseFloat(analysis[key]["ask"]),
          openInterest: parseInt(analysis[key]["openInterest"]),
          volume: parseInt(analysis[key]["volume"]),
          profit: parseFloat(analysis[key]["bid"]),
          annualProfit: parseFloat(analysis[key]["annualProfit"]),
          depth: parseFloat(analysis[key]["depth"]),
          wAvgChange: parseFloat(analysis[key]["weightedAvgChgPercent"]),
          impliedVol: parseFloat(analysis[key]["impliedVol"]),
          impliedPeriod: parseFloat(analysis[key]["impliedPeriod"]),
          minPrice: parseFloat(analysis[key]["minPrice"]),
          maxPrice: parseFloat(analysis[key]["maxPrice"])
        }
      }
      if (activeButton.toString().toLowerCase() === "longterm") {
        //console.log("loadRowData : inside longterm")
        let marketCap = 0;

        if (!isNaN(parseFloat(analysis[key]["marketCap"]))) { 
            marketCap = parseFloat(analysis[key]["marketCap"]);
        }
        //console.log("marketCap = "+marketCap );

        let dividendYield = 0;
        if (!isNaN(parseFloat(analysis[key]["dividendYield"]))) {
            dividendYield = parseFloat(analysis[key]["dividendYield"]);
        }

        let dividendRate = 0;
        if (!isNaN(parseFloat(analysis[key]["dividendRate"]))) {
            dividendRate = parseFloat(analysis[key]["dividendRate"]);
        }

        let forwardPE = 0;
        if (!isNaN(parseFloat(analysis[key]["forwardPE"]))) {
            forwardPE = parseFloat(analysis[key]["forwardPE"]);
        }

        let netExpenseRatio = 0;
        if (!isNaN(parseFloat(analysis[key]["netExpenseRatio"]))) {
            netExpenseRatio = parseFloat(analysis[key]["netExpenseRatio"]);
        }

        let ytdReturn = 0;  
        if (!isNaN(parseFloat(analysis[key]["ytdReturn"]))) {
            ytdReturn = parseFloat(analysis[key]["ytdReturn"]);
        }

        let peRatio = 0;
        if (!isNaN(parseFloat(analysis[key]["trailingPE"]))) {
            peRatio = parseFloat(analysis[key]["trailingPE"]);
        }

        let eps = 0;
        if (!isNaN(parseFloat(analysis[key]["epsCurrentYear"]))) {
            eps = parseFloat(analysis[key]["epsCurrentYear"]);
        }

        let priceToBook = 0;
        if (!isNaN(parseFloat(analysis[key]["priceToBook"]))) {
            priceToBook = parseFloat(analysis[key]["priceToBook"]);
        }

        let trailingAnnualDividendYield = 0;
        if (!isNaN(parseFloat(analysis[key]["trailingAnnualDividendYield"]))) {
          trailingAnnualDividendYield = parseFloat(analysis[key]["trailingAnnualDividendYield"]);
        }

        let lastSale = 0;
        if (!isNaN(parseFloat(analysis[key]["regularMarketPrice"]))) {
          lastSale = parseFloat(analysis[key]["regularMarketPrice"]);
        }

        let rating = "";
        try {
          rating = analysis[key]["averageAnalystRating"];
        } catch(err) { };

        let deepFiftyTwoWeeks = 0;
        try {
          if (!isNaN(parseFloat(analysis[key]["fiftyTwoWeekHigh"]))) {
            deepFiftyTwoWeeks = lastSale / parseFloat(analysis[key]["fiftyTwoWeekHigh"]) * 100;
            deepFiftyTwoWeeks = deepFiftyTwoWeeks.toFixed(2);
            deepFiftyTwoWeeks = parseFloat(deepFiftyTwoWeeks);
          }
        } catch(err) { };

        rowdata[key]={
          id: key,
          expanded: false,
          security: analysis[key]["symbol"],
          name: analysis[key]["longName"],
          lastSale: lastSale,
          marketCap: marketCap,
          peRatio: peRatio,
          netExpenseRatio: netExpenseRatio,
          dividendYield: dividendYield,
          dividendRate: dividendRate,
          fiftyTwoWeekLow: analysis[key]["fiftyTwoWeekLow"],
          fiftyTwoWeekHigh: analysis[key]["fiftyTwoWeekHigh"],
          fiftyTwoWeekChangePercent: parseFloat(analysis[key]["fiftyTwoWeekChangePercent"]),
          lastSalePercentOfFiftyTwoWeekHigh: deepFiftyTwoWeeks,
          eps: eps,
          rating: rating,
          regularMarketChange: parseFloat(analysis[key]["regularMarketChange"]),
          regularMarketVolume: parseFloat(analysis[key]["regularMarketVolume"]),
          averageDailyVolume3Month: parseFloat(analysis[key]["averageDailyVolume3Month"]),
          ytdReturn: ytdReturn,
          relatedSecurities: analysis[key]["relatedSecurities"],
          bid: parseFloat(analysis[key]["bid"]),
          offer: parseFloat(analysis[key]["ask"]),
          forwardPE: forwardPE,
          priceToBook: priceToBook,         
          trailingAnnualDividendYield: trailingAnnualDividendYield,
          details: "> ",
          compare: "Compare"
        }
      }
    }
    console.log("loadRowData : rowdata.length = "+rowdata.length);
    
  }
  return rowdata;
}

let email="";

async function setEmail() {
  await console.log("Executing setEmail");
    return (
      new Promise(async (resolve, reject)=>{
        await Auth.fetchUserAttributes().then(async user=>{
          await console.log("setEmail : email with value = "+JSON.stringify(user.attributes.email));
          email = await user.attributes.email;
          await console.log("setEmail email = "+email)
        })
        await setTimeout(() => resolve("done"), 3000);
      })
    )
}

export async function getUserInfo() {
  await console.log("Executing getUserInfo");
  if (email === "" || typeof(email) === 'undefined'){
    await setEmail().then(async (res)=>{
      await console.log ("email in getUserInfo = " + email)
      await console.log("res in getUserInfo = "+res);
    })
  }
  return email;
}

let initString = "";

export async function downloadFile(file) {
  await console.log("Executing downloadFile");
  await console.log("downloadFile : received file - " + file);
  let initString = {};
  const myAPI="mktappapi";
  let path = '/getProfile';
  var passApistr=path + "/" + file.toString();
  console.log("downloadFile : passApistr = " +passApistr);
  /*await get(myAPI, passApistr)
  .then(async (result) => {
    initString = await result;
  })*/
  const response = await get({
    apiName: myAPI,
    path: passApistr,
  }).response;

  initString = await response.body.json();

  await console.log ("downloadFile : initString = " + JSON.stringify(initString));
  return await initString;
}

export async function uploadFile(file, settingsStr) {
  let uploadResult;
  await console.log("Executing uploadFile");
  await console.log("uploadFile : received file - " + file);
  await console.log("uploadFile : received settingsStr - " + JSON.stringify(settingsStr));

  const myAPI="mktappapi";
  let path = '/saveProfile';
  var passApistr=path + "/" + file.toString() + "/" + JSON.stringify(settingsStr);
  console.log("uploadloadFile : passApistr = " +passApistr);
  const response = await get({
    apiName: myAPI,
    path: passApistr,
  }).response;
  let resp = response.body.json();
  await Promise.resolve(resp)
  .then(async (result) => {
    await console.log ("uploadFile : completed the upload");
    uploadResult = await "completed the upload";
  })
  .catch(error => {
    console.log("uploadFile : error = " + error);
    uploadResult = error;
  })
  console.log("uploadFile : uploadResult = " + uploadResult);
  return uploadResult;
}

export async function strategy(params, activeButton) {
  await console.log("Executing strategy");
  await console.log("newstrategy : params = "+params);
  await console.log("newstrategy : activeButton = "+activeButton);
  let analysis = [];

  const myAPI="mktappapi";
  let path = '/newstrategy';
  //countOfResponses.current++;
  //await console.log ("newstrategy : data = " + JSON.stringify(data));
  //await console.log ("newstrategy : stocks.current[stocks] = " + stocks.current["stocks"]);

  var paramsJSON=JSON.parse(params);
  await console.log ("newstrategy : paramsJSON = " + JSON.stringify(paramsJSON));

  var passApistr=path + "/" + paramsJSON.days + "/" + paramsJSON.daysOffset + "/" + paramsJSON.minDepth + "/" + paramsJSON.stocks.toString() + "/" + activeButton + "/" + 
     paramsJSON.useThirdFriday + "/" + paramsJSON.startingFromThisMonth;
  console.log("newstrategy : passApiStr = "+passApistr);
  const response = await get({
    apiName: myAPI,
    path: passApistr,
  }).response;
  let resp = response.body.json();
  await Promise.resolve(resp)
  .then(async () => {
    await console.log("newstrategy : response = " + JSON.stringify(resp));
    analysis = await resp;
    await console.log("newstrategy : analysis.length = " + analysis.length);
    //setCounter(countOfResponses.current);
    var count = Object.keys(resp).length;
    /*if (countOfResponses.current === numOfStocks.current && count === 0) {
    //setShowLoading(false);
    }*/
    /*if (count>0){
      //await sepElements(response);
      await loadRowData(analysis);
    }*/
    console.log("newstrategy : analysis");
    console.log(analysis);
    
  })
  return analysis;
}

export async function strategyLongTerm(params) {
  await console.log("Executing strategyLongTerm");
  await console.log("strategyLongTerm : params = "+params);
  let analysis = [];

  const myAPI="mktappapi";
  let path = 'https://tgszfs32y3lqnftikx5jhuika40npdkt.lambda-url.us-east-1.on.aws';

  var paramsJSON=JSON.parse(params);
  await console.log ("strategyLongTerm : paramsJSON = " + JSON.stringify(paramsJSON));

  var passApistr=path + "/?securities=" + paramsJSON.stocks.toString();
  console.log("strategyLongTerm : passApiStr = "+passApistr);
  await axios.get(passApistr)
  .then(async resp => {
    await console.log("strategyLongTerm : response = " + JSON.stringify(resp));
    analysis = await resp.data;
    await console.log("strategyLongTerm : analysis.length = " + analysis.length);
    //setCounter(countOfResponses.current);
    var count = Object.keys(resp).length;
    /*if (countOfResponses.current === numOfStocks.current && count === 0) {
    //setShowLoading(false);
    }*/
    /*if (count>0){
      //await sepElements(response);
      await loadRowData(analysis);
    }*/
    console.log("strategyLongTerm : analysis");
    console.log(analysis);
    
  })
  return analysis;
}

export async function strategyetfs(params, activeButton) {
  await console.log("Executing strategyetfs");
  await console.log("strategyetfs : params = "+params);
  let analysis = [];

  const myAPI="mktappapi";
  let path = 'https://s472m5jmsch6mb5waf6co7by5i0eutct.lambda-url.us-east-1.on.aws';

  var paramsJSON=JSON.parse(params);
  await console.log ("strategyetfs : paramsJSON = " + JSON.stringify(paramsJSON));

  var passApistr=path + "/?days=" + paramsJSON.days + "&daysOffset=" + paramsJSON.daysOffset + 
    "&minDepth=" + paramsJSON.minDepth + "&direction=" + activeButton + "&excludeLeveragedEtfs=" + paramsJSON.excludeLeveragedEtfs +
    "&useThirdFriday=" + paramsJSON.useThirdFriday + "&startingFromThisMonth=" + paramsJSON.startingFromThisMonth;
  console.log("strategyetfs : passApiStr = "+passApistr);
  await axios.get(passApistr)
  //await get(myAPI, passApistr)
  .then(async response => {
    await console.log("strategyetfs : response = " + JSON.stringify(response));
    analysis = await response.data;
    await console.log("strategyetfs : analysis.length = " + analysis.length);
    console.log("strategyetfs : analysis");
    console.log(analysis);
  })
  .catch(async error =>{
    console.log ("strategyetfs : Error processing response");
    console.log(error);
  })
  return analysis;
}

async function listFiles() {
  let data = {};
  await console.log("Executing listFiles");
  await console.log("in listFiles");
  await console.log("listFiles : email = "+email.current);
  await Storage.list('', { level: 'public' })
  .then(async ({ results }) => {
    await console.log(results);
    if (typeof (email.current) !== "undefined"){
      await console.log("listFiles : results size = "+results.length);
      var i;
      var found=false;
      for (i=0; i<results.length; i++){
        //await console.log("listFiles : key " + i + " = "+results[i].key);
        if (results[i].key.toString().toLowerCase().trim()===email.current.toLowerCase().trim()){
          await console.log("listFiles : emails matched = "+email.current);

          data = await JSON.parse(await downloadFile(email.current));
          i=results.length
          found=true;
        }
      }
      if (!found) {
        await console.log("email was not found");
        data = await JSON.parse(await downloadFile("default.json"));
      }
    }
  })
  .catch((err) => console.log(err.message));  
  return await data
}

export function analyzeBearBull (optionsLegsDetails, lastSale) {
  console.log("Executing analyzeOpenInterestBearBull");
  console.log("analyzeOpenInterestBearBull : optionsLegsDetails = ", optionsLegsDetails);
  console.log("analyzeOpenInterestBearBull : optionsLegsDetails.length = ", optionsLegsDetails.length);
  console.log("analyzeOpenInterestBearBull : optionsLegsDetails[0] = ", optionsLegsDetails[0]);
  console.log("analyzeOpenInterestBearBull : lastSale = ", lastSale);
  let bearBullAnalysis = {};
  let openInterestAnalysis = "";
  let totalOpenInterestCalls = 0;
  let totalOpenInterestPuts = 0;
  let pcr = 0;
  let pcrAnalysis = "";
  let iv = "";
  let optionDeltaDistribution = "";
  let skewnessStrikePrices = "";
  let greeks = "";
  let strikeProximity = "";
  let bidAskSpread = "";

  for (let detInd = 0; detInd < optionsLegsDetails.length; detInd++) {

    if (optionsLegsDetails[detInd]) {
      if (optionsLegsDetails[detInd].type === "call") {
        if (optionsLegsDetails[detInd].openInterest) {
          totalOpenInterestCalls += optionsLegsDetails[detInd].openInterest;
        }
      } else {
        if (optionsLegsDetails[detInd].openInterest) {
          totalOpenInterestPuts += optionsLegsDetails[detInd].openInterest;
        }
      }
    }
  }
  console.log("analyzeOpenInterestBearBull : totalOpenInterestCalls = ", totalOpenInterestCalls);
  console.log("analyzeOpenInterestBearBull : totalOpenInterestPuts = ", totalOpenInterestPuts);

  if (totalOpenInterestCalls > totalOpenInterestPuts) {
    openInterestAnalysis = "Bullish";
  } else if (totalOpenInterestCalls < totalOpenInterestPuts) {
    openInterestAnalysis = "Bearish";
  } else {
    openInterestAnalysis = "Neutral";
  }

  if (totalOpenInterestCalls > 0 && totalOpenInterestPuts > 0) {
    pcr = totalOpenInterestPuts / totalOpenInterestCalls;
    if (pcr > 1) {
      pcrAnalysis = "Bearish";
    } else if (pcr < 1) {
      pcrAnalysis = "Bullish";
    } else {
      pcrAnalysis = "Neutral";
    }
  }

  iv = analyzeIvBearBull(optionsLegsDetails);
  optionDeltaDistribution = analyzeOptionDeltaDistribution(optionsLegsDetails);
  skewnessStrikePrices = analyzeSkewnessStrikePrices(optionsLegsDetails);
  greeks = analyzeGreeks(optionsLegsDetails);
  strikeProximity = strikeProximityBearBull(optionsLegsDetails, lastSale);
  bidAskSpread = analyzeBidAskSpread(optionsLegsDetails);

  bearBullAnalysis.openInterest = openInterestAnalysis;
  bearBullAnalysis.pcr = pcrAnalysis;
  bearBullAnalysis.iv = iv;
  bearBullAnalysis.optionDeltaDistribution = optionDeltaDistribution;
  bearBullAnalysis.skewnessStrikePrices = skewnessStrikePrices;
  bearBullAnalysis.greeks = greeks;
  bearBullAnalysis.strikeProximity = strikeProximity;
  bearBullAnalysis.bidAskSpread = bidAskSpread;
  bearBullAnalysis.overAll = overallSentimentBullBear(bearBullAnalysis);
  console.log("analyzeOpenInterestBearBull : bearBullAnalysis = ", bearBullAnalysis);

  return bearBullAnalysis;
}

  const overallSentimentBullBear = (bearBullAnalysis) => {
    console.log("Executing overallSentimentBullBear");
    console.log("overallSentimentBullBear : bearBullAnalysis = ", bearBullAnalysis);
    // Convert the sentiment to numerical scores for calculation
    const sentimentScores = {
      "Bullish": 1,
      "Bearish": -1,
      "Neutral": 0
    };

    let analysisWeights = {
      "greeksWeight": 2,  // High importance
      "strikeProximityWeight": 1.5,  // Medium importance
      "openInterestWeight": 1,  // Medium-Low importance
      "optionDeltaDistributionWeight": 1.5,  // Medium importance
      "pcrWeight": 1,  // Medium-Low importance
      "ivWeight": 1.5,  // Medium-High importance
      "skewnessStrikePrices": 1,  // Medium-Low importance
      "bidAskSpreadWeight": 1.25  // Medium importance (added for bid-ask spread)
    }
  
    // Calculate the weighted score for each analysis
    let totalScore = 0;
    totalScore += sentimentScores[bearBullAnalysis.greeks] * analysisWeights.greeksWeight;
    totalScore += sentimentScores[bearBullAnalysis.strikeProximity] * analysisWeights.strikeProximityWeight;
    totalScore += sentimentScores[bearBullAnalysis.openInterest] * analysisWeights.openInterestWeight;
    totalScore += sentimentScores[bearBullAnalysis.optionDeltaDistribution] * analysisWeights.optionDeltaDistributionWeight;
    totalScore += sentimentScores[bearBullAnalysis.pcr] * analysisWeights.pcrWeight;
    totalScore += sentimentScores[bearBullAnalysis.iv] * analysisWeights.ivWeight;
    totalScore += sentimentScores[bearBullAnalysis.skewnessStrikePrices] * analysisWeights.skewnessStrikePrices;
    totalScore += sentimentScores[bearBullAnalysis.bidAskSpread] * analysisWeights.bidAskSpreadWeight;
    console.log("overallSentimentBullBear : totalScore = ", totalScore);
  
    // Determine overall sentiment based on the total score
    if (totalScore > 0) {
      return "Bullish";
    } else if (totalScore < 0) {
      return "Bearish";
    } else {
      return "Neutral";
    }
  };

  const analyzeBidAskSpread = (optionsLegsDetails) => {
    console.log("Executing analyzeBidAskSpread");
  
    if (!Array.isArray(optionsLegsDetails) || optionsLegsDetails.length === 0) {
      console.error('analyzeBidAskSpread: Invalid input: optionsLegsDetails is not an array or is empty.');
      return 'Neutral'; // Default to neutral if the array is empty or invalid.
    }
  
    // Separate call and put options
    const calls = optionsLegsDetails.filter(option => option.type === 'call' && option.bid !== undefined && option.ask !== undefined);
    const puts = optionsLegsDetails.filter(option => option.type === 'put' && option.bid !== undefined && option.ask !== undefined);
  
    if (calls.length === 0 || puts.length === 0) {
      console.error('analyzeBidAskSpread: Missing valid call or put data.');
      return 'Neutral';
    }
  
    // Calculate the average bid-ask spread for calls and puts
    const averageCallSpread = calls.reduce((sum, option) => sum + (option.ask - option.bid), 0) / calls.length;
    const averagePutSpread = puts.reduce((sum, option) => sum + (option.ask - option.bid), 0) / puts.length;
  
    console.log("analyzeBidAskSpread: averageCallSpread =", averageCallSpread);
    console.log("analyzeBidAskSpread: averagePutSpread =", averagePutSpread);
  
    // Analyze the spreads to determine sentiment
    if (averageCallSpread < averagePutSpread) {
      // Tighter spreads for calls indicate stronger demand and liquidity, suggesting bullish sentiment
      return 'Bullish';
    } else if (averagePutSpread < averageCallSpread) {
      // Tighter spreads for puts indicate stronger demand and liquidity, suggesting bearish sentiment
      return 'Bearish';
    } else {
      return 'Neutral'; // If the spreads are similar, the sentiment is neutral
    }
  };

  const strikeProximityBearBull = (optionsLegsDetails, underlyingPrice) => {
    console.log("Executing strikeProximityBearBull");
    console.log("strikeProximityBearBull : optionsLegsDetails = ", optionsLegsDetails);
    console.log("strikeProximityBearBull : underlyingPrice = ", underlyingPrice);
    // Identify the ATM strike (closest to the current underlying price)
    let atmStrike = optionsLegsDetails.reduce((prev, curr) => {
      return Math.abs(curr.strike - underlyingPrice) < Math.abs(prev.strike - underlyingPrice)
        ? curr
        : prev;
    });
    console.log("strikeProximityBearBull : atmStrike = ", atmStrike);
  
    // Separate call and put options near the ATM strike
    const nearAtmCalls = optionsLegsDetails.filter(
      (option) =>
        option.type === "call" &&
        Math.abs(option.strike - atmStrike.strike) <= 5 // adjust range if needed
    );
    console.log("strikeProximityBearBull : nearAtmCalls = ", nearAtmCalls)
  
    const nearAtmPuts = optionsLegsDetails.filter(
      (option) =>
        option.type === "put" &&
        Math.abs(option.strike - atmStrike.strike) <= 5 // adjust range if needed
    );
    console.log("strikeProximityBearBull : nearAtmPuts = ", nearAtmPuts)
  
    // Calculate the sum of open interest for calls and puts near ATM
    const totalCallOpenInterest = nearAtmCalls.reduce(
      (sum, option) => sum + option.openInterest,
      0
    );
    console.log("strikeProximityBearBull : totalCallOpenInterest = ", totalCallOpenInterest)
    const totalPutOpenInterest = nearAtmPuts.reduce(
      (sum, option) => sum + option.openInterest,
      0
    );
    console.log("strikeProximityBearBull : totalPutOpenInterest = ", totalPutOpenInterest)
  
    // Determine the sentiment based on strike proximity and positioning
    if (totalCallOpenInterest > totalPutOpenInterest) {
      return "Bullish";
    } else if (totalPutOpenInterest > totalCallOpenInterest) {
      return "Bearish";
    } else {
      return "Neutral";
    }
  };

  const analyzeGreeks = (optionsLegsDetails) => {
    let totalCallDelta = 0;
    let totalPutDelta = 0;
    let totalCallGamma = 0;
    let totalPutGamma = 0;
    let totalCallVega = 0;
    let totalPutVega = 0;
  
    // Aggregate Greeks based on option type
    optionsLegsDetails.forEach((option) => {
      if (option.type === 'call') {
        if (option.delta) {
          totalCallDelta += option.delta;
        }
        if (option.gamma) {
          totalCallGamma += option.gamma;
        }
        if (option.vega) {
          totalCallVega += option.vega;
        }
      } else if (option.type === 'put') {
        if (option.delta) {
          totalPutDelta += option.delta;
        }
        if (option.gamma) {
          totalPutGamma += option.gamma;
        }
        if (option.vega) {
          totalPutVega += option.vega;
        }
      }
    });
  
    // Analyze sentiment based on aggregated Greeks
    const isBullish =
      totalCallDelta > Math.abs(totalPutDelta) &&
      totalCallGamma > totalPutGamma &&
      totalCallVega > totalPutVega;
  
    const isBearish =
      totalPutDelta < -Math.abs(totalCallDelta) &&
      totalPutGamma > totalCallGamma &&
      totalPutVega > totalCallVega;
  
    if (isBullish) {
      return 'Bullish';
    } else if (isBearish) {
      return 'Bearish';
    } else {
      return 'Neutral';
    }
  };

  const analyzeSkewnessStrikePrices = (optionsLegsDetails) => {
    console.log("Executing analyzeSkewnessStrikePrices");
    if (!Array.isArray(optionsLegsDetails) || optionsLegsDetails.length === 0) {
      console.error('analyzeSkewnessStrikePrices : Invalid input: optionsLegsDetails is not an array or is empty.');
      return 'Neutral'; // Default to neutral if the array is empty or invalid.
    }
  
    // Separate call and put options
    const calls = optionsLegsDetails.filter(option => option.type === 'call' && typeof option.impliedVolatility === 'number');
    const puts = optionsLegsDetails.filter(option => option.type === 'put' && typeof option.impliedVolatility === 'number');
  
    // Calculate the average implied volatility for calls and puts
    const averageCallIV = calls.reduce((sum, option) => sum + option.impliedVolatility, 0) / calls.length;
    const averagePutIV = puts.reduce((sum, option) => sum + option.impliedVolatility, 0) / puts.length;
  
    // Determine the skewness
    const skew = averagePutIV - averageCallIV;
  
    // Analyze the skewness to determine sentiment
    if (skew > 0.05) {
      console.log("analyzeSkewnessStrikePrices : skew = ", skew);
      return 'Bearish'; // Higher put IV relative to call IV indicates bearish sentiment
    } else if (skew < -0.05) {
      console.log("analyzeSkewnessStrikePrices : skew = ", skew);
      return 'Bullish'; // Higher call IV relative to put IV indicates bullish sentiment
    } else {
      console.log("analyzeSkewnessStrikePrices : skew = ", skew);
      return 'Neutral'; // Minimal skew suggests neutral sentiment
    }
  };

  function analyzeOptionDeltaDistribution(optionsLegsDetails) {
    console.log("Executing analyzeOptionDeltaDistribution");
    // Aggregate deltas for calls and puts
    let totalCallDelta = 0;
    let totalPutDelta = 0;
  
    console.log("analyzeOptionDeltaDistribution: optionsLegsDetails = ", optionsLegsDetails);
    optionsLegsDetails.forEach((option) => {
      if (option.type === "call") {
        if (option.delta) {
          totalCallDelta += option.delta;
        }
      } else if (option.type === "put") {
        if (option.delta) {
          totalPutDelta += option.delta;
        }
      }
    });
    console.log("analyzeOptionDeltaDistribution: totalCallDelta = ", totalCallDelta);
    console.log("analyzeOptionDeltaDistribution: totalPutDelta = ", totalPutDelta);
  
    // Calculate net delta
    const netDelta = totalCallDelta + totalPutDelta;
  
    // Determine market sentiment
    console.log("analyzeOptionDeltaDistribution : netDelta = ", netDelta);
    if (netDelta > 0.5) {
      return "Bullish";
    } else if (netDelta < -0.5) {
      return "Bearish";
    } else {
      return "Neutral";
    }
  }

  const analyzeIvBearBull = (options) => {
    let totalCallIV = 0;
    let totalPutIV = 0;
    let callCount = 0;
    let putCount = 0;
  
    options.forEach((option) => {
      if (option.type === "call") {
        if (option.implied_volatility) {
          totalCallIV += option.implied_volatility;
          callCount += 1;
        }
      } else if (option.type === "put") {
        if (option.implied_volatility) {
          totalPutIV += option.implied_volatility;
          putCount += 1;
        }
      }
    });
  
    const averageCallIV = callCount > 0 ? totalCallIV / callCount : 0;
    const averagePutIV = putCount > 0 ? totalPutIV / putCount : 0;
  
    // Determine sentiment
    if (averageCallIV < averagePutIV) {
      return "Bearish";
    } else if (averageCallIV > averagePutIV) {
      return "Bullish";
    } else {
      return "Neutral";
    }
  };